import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import React from 'react'

interface Props {
  name: string
}

function MultiCartBookedByLabel({ name }: Props) {
  return <StatusLabel variant="confirmation" startIcon={<LineCheckCircleIcon />}>
    Booked by {name}
  </StatusLabel>
}

export default MultiCartBookedByLabel
